import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/dist/client/app-dir/link.js");
